<template>
	<div class="card mt-4">
        <div class="card-header">
            <div class="row">
	            <div class="d-flex justify-content-between container-fluid">
			        <div class="text-muted fs-19">
			            <strong>Totais</strong>
			        </div>
				</div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
            	<div class="col-xl-3 col-md-6 mb-4">
            		<bga2-info-card classe="border-left-primary">
            			<div class="col mr-2">
		        			<div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
		            			Total de Categorias
		        			</div>
		        			<div class="h5 mb-0 font-weight-bold text-gray-800">
		        				{{ dados.total }}	
		        			</div>
		    			</div>
						<div class="col-auto">
		        			<i class="fas fa-tags fa-2x text-gray-300"></i>
		    			</div>
            		</bga2-info-card>
            	</div>
            	<div class="col-xl-3 col-md-6 mb-4">
            		<bga2-info-card classe="border-left-primary">
            			<div class="col mr-2">
		        			<div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
		            			Categorias com Vendas
		        			</div>
		        			<div class="h5 mb-0 font-weight-bold text-gray-800">
		        				{{ dados.total_com_vendas }}	
		        			</div>
		    			</div>
						<div class="col-auto">
		        			<i class="fas fa-chart-line fa-2x text-gray-300"></i>
		    			</div>
            		</bga2-info-card>
            	</div>
            	<div class="col-xl-3 col-md-6 mb-4">
            		<bga2-info-card classe="border-left-primary">
            			<div class="col mr-2">
		        			<div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
		            			Categorias Vendidas no Ano
		        			</div>
		        			<div class="h5 mb-0 font-weight-bold text-gray-800">
		        				{{ dados.total_com_vendas_ano }}	
		        			</div>
		    			</div>
						<div class="col-auto">
		        			<i class="fas fa-calendar fa-2x text-gray-300"></i>
		    			</div>
            		</bga2-info-card>
            	</div>
            	<div class="col-xl-3 col-md-6 mb-4">
            		<bga2-info-card classe="border-left-primary">
            			<div class="col mr-2">
		        			<div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
		            			Categorias Vendidas no Mês
		        			</div>
		        			<div class="h5 mb-0 font-weight-bold text-gray-800">
		        				{{ dados.total_com_vendas_mes }}
		        			</div>
		    			</div>
						<div class="col-auto">
		        			<i class="fas fa-calendar-alt fa-2x text-gray-300"></i>
		    			</div>
            		</bga2-info-card>
            	</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['date'],
		data(){
			return {
				dados: []
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/relatorios/categorias/'+this.date)
	            .then(response => {
	            	this.dados = response.data;
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
		},
	}
</script>
